import 'css-chunksrc/client/scenes/allocationWarnings/styles.scss';export default {
  "header": "_header_fmuwn_1",
  "title": "_title_fmuwn_8",
  "body": "_body_fmuwn_16",
  "intro": "_intro_fmuwn_20",
  "list": "_list_fmuwn_27",
  "item": "_item_fmuwn_32",
  "resource": "_resource_fmuwn_40",
  "avatar": "_avatar_fmuwn_47",
  "resourceName": "_resourceName_fmuwn_52",
  "warningDetails": "_warningDetails_fmuwn_58",
  "actions": "_actions_fmuwn_68"
};